/*!
* name ZJX 上传
* Copyright 2018-2019
*/
<template>
  <div class>
    <publicNav></publicNav>
    <div class="process">
      <ul class="clearfix">
        <li
          v-for="(item,index) in processList"
          :class="(index+1)==isProcess?'processCur':''"
          :key="index">
          <em>{{item.id}}</em>
          <span>{{item.processName}}</span>
        </li>
      </ul>
    </div>
    <div class="formUpload" v-if="upload">
      <el-form ref="ruleForm" :rules="rules" :model="ruleForm" label-width="98px">
        <el-form-item label="类型选择" prop="switchBtn">
          <div class="switchBtn" :style="{'width':centerArr.length<=1?'80px':'160px'}">
            <span
              :class="item.className"
              v-for="(item,index) in centerArr"
              :key="index"
              @click="onCenterpos()"
            >{{item.nameTitle}}</span>
            <span class="center_pos" id="center_pos">{{centerPos}}</span>
          </div>
        </el-form-item>

        <el-form-item :label="centervalidate == 1 ? '资源标题' : '作品标题'" prop="name">
          <el-input v-model="ruleForm.name"
                    :placeholder="centervalidate == 1 ? resourcePlaceholder : worksPlaceholder"
                    maxlength="50"></el-input>
        </el-form-item>

        <el-form-item v-if="centervalidate == 0" :label="centervalidate == 1 ? '资源类型' : '作品类型'" prop="region">
          <el-select v-model="ruleForm.region" placeholder="请选择作品类型">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="发送老师" prop="send">
          <el-select v-model="ruleForm.send" placeholder="请选择发送老师">
            <el-option
              v-for="item in optionsData"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="上传文件" class="upload-file-row">
          <el-upload
            class="upload-jpg"
            v-model="ruleForm.file"
            :before-upload="beforeJPGUpload"
            :on-change="handleJPGChange"
            :on-remove="handleJPGRemove"
            :file-list="uploadJPG"
            :action="urlData"
            :headers="token"
          >
            <el-button size="middle" type="primary">选择上传jpg文件</el-button>
            <div slot="tip" class="el-upload__tip">同一图片需要上传jpg/hua两个格式文件,单个文件不能超过200M</div>
          </el-upload>
          <el-upload class="upload-jpg"
                     v-model="ruleForm.file"
                     :before-upload="beforeHUAUpload"
                     :on-change="handleHUAChange"
                     :on-remove="handleHUARemove"
                     :file-list="uploadHUA"
                     :action="urlData"
                     :headers="token"
          >
            <el-button size="middle" type="primary">选择上传hua文件</el-button>
          </el-upload>
          <el-upload v-if="centervalidate == 1"
                     class="upload-jpg"
                     v-model="ruleForm.file"
                     :before-upload="beforeZIPUpload"
                     :on-change="handleZIPChange"
                     :on-remove="handleZIPRemove"
                     :file-list="uploadZIP"
                     :action="urlData"
                     :headers="token"
          >
            <el-button size="middle" type="primary">选择上传zip文件</el-button>
          </el-upload>
          <span class="fileIntro">{{uploadText}}</span>
        </el-form-item>

        <el-form-item label="描述" prop="desc">
          <el-input type="textarea" v-model="ruleForm.desc" placeholder="支持汉字、字母、数字、字符长度控制1-5000个"></el-input>
        </el-form-item>

        <div class="information_btn uploadbox">
          <el-button
            type="primary"
            size="medium"
            class="information_modify_btn"
            @click="submitForm('ruleForm')"
          >提交
          </el-button>
        </div>
      </el-form>
    </div>
    <!-- 上传成功 S-->
    <div class="uploadSuccess" v-if="successTip">
      <img src="../../assets/images/paysucceed.png" alt>
      <p v-if="isShow == 2 || !isShow">您的{{centervalidate===1?'资源':'作品'}}已上传完成，对应老师审核通过后将公开展示。</p>
      <p v-else>您的作品/资源已上传完成，对应老师审核通过后将公开展示。</p>
      <p>
        <el-button type="primary" @click="refreshView('成功')">好的</el-button>
      </p>
    </div>
    <!-- 上传成功 E-->
    <!-- 重新上传 S-->
    <div class="uploadSuccess" v-if="failTip">
      <img src="../../assets/images/fail.png" alt>
      <p v-if="isShow == 2 || !isShow">您的{{centervalidate===1?'资源':'作品'}}上传失败,请重新上传！</p>
      <p v-else>您的作品/资源上传失败,请重新上传！</p>
      <p>
        <el-button type="primary" @click="refreshView('失败')">重新上传</el-button>
      </p>
    </div>
    <!-- 重新上传 E-->
  </div>
</template>

<script>
import publicNav from '@/components/publicnav' //引入公共页签
import cacheUtils from '@/common/cacheUtils' //调用缓存
import apiInterface from '@/api/index' //接口
export default {
  data () {
    return {
      ruleForm: {
        name: '',
        region: '',
        send: '',
        desc: ''
      },
      urlData: apiInterface.worksUploadFile, // 上传作品文件
      token: { Authorization: 'Bearer' + cacheUtils.cookie.getObject('Token') },
      options: [],
      optionsData: [],
      rules: {
        name: [
          { required: true, message: '请输入作品标题', trigger: 'blur' },
          { min: 0, max: 100, message: '长度在 3 到 5 个字符', trigger: 'blur' }
        ],
        region: [
          { required: true, message: '请选择作品类型', trigger: 'change' }
        ],
        send: [
          { required: true, message: '请选择发送老师', trigger: 'change' }
        ],
        desc: [{ required: true, message: '请填写描述', trigger: 'blur' }
        ]
      },
      // 上传
      fileList3: [],
      processList: [
        {
          processName: '上传',
          id: 1
        },
        {
          processName: '等待审核',
          id: 2
        },
        {
          processName: '发布成功',
          id: 3
        }
      ],
      isProcess: '',
      fileLength: [],
      isShow: false,
      uploadText: '',
      centerPos: '作品',
      centerArr: [
        {
          id: 1,
          nameTitle: '作品',
          className: 'left_btn'
        },
        {
          id: 2,
          nameTitle: '资源',
          className: 'right_btn'
        }
      ],
      centervalidate: 0,
      successTip: false, // 成功提示
      failTip: false, // 失败提示
      upload: true, // 上传内容
      isShow: cacheUtils.sessionStorage('status').get('zjx'),
      userName: '',
      worksPlaceholder: '请输入作品标题',
      resourcePlaceholder: '请输入资源标题',
      uploadJPG: [], // 上传jpg文件
      uploadHUA: [], // 上传hua文件
      uploadZIP: [] // 上传zip文件
    }
  },
  computed: {},
  mounted () {},
  components: {
    publicNav
  },
  methods: {
    // 上传文件之前的钩子 JPG
    beforeJPGUpload (file) {
      console.log('1:', 1)
      const isJPG = file.type === 'image/jpeg'
      const isLt2M = file.size / 1024 / 1024 < 200
      if (!isJPG) {
        this.$message.error('上传文件只能是 JPG 格式!')
        return isJPG
      }
      if (!isLt2M) {
        this.$message.error('上传文件大小不能超过 200MB!')
        return isLt2M
      }
      let fd = new FormData()
      fd.append('file', file)
      fd.append('type', 'jpg')
      const postUrl = this.centervalidate == 0 ? 'http://api.lehuawang.dzhhb.com/api/v1/works/upload-file' : 'http://api.lehuawang.dzhhb.com/api/v1/resources/upload-file'
      this.$xhr.post(postUrl, fd)
        .then(res => {
          this.uploadJPG.push({
            name: res.data.file_name,
            url: res.data.file_path,
            id: res.data.id
          })
        })
        .catch(err => {
          this.$message.error(err.message)
        })
    },
    // 文件状态改变时的钩子 JPG
    handleJPGChange (file) {
      if (!file.name) {
        this.isShow = true
        this.uploadText = '请上传作品'
      } else {
        this.fileLength.push(file.name)
        this.isShow = false
        this.uploadText = ''
      }
    },
    // 文件列表移除文件时的钩子 JPG
    handleJPGRemove (file) {
      this.uploadJPG = this.uploadJPG.filter(item => {
        return item.id !== file.id
      })
    },
    // 上传文件之前的钩子 HUA
    beforeHUAUpload (file) {
      let fileType = file.type
      if (!file.type) {
        fileType = file.name.split('.')[1]
      }
      const isHUA = fileType === 'hua'
      const isLt2M = file.size / 1024 / 1024 < 200
      if (!isHUA) {
        this.$message.error('上传文件只能是 hua 格式!')
        return isHUA
      }
      if (!isLt2M) {
        this.$message.error('上传文件大小不能超过 200MB!')
        return isLt2M
      }
      let fd = new FormData()
      fd.append('file', file)
      fd.append('type', 'hua') // 其他参数
      const postUrl = this.centervalidate == 0 ? 'http://api.lehuawang.dzhhb.com/api/v1/works/upload-file' : 'http://api.lehuawang.dzhhb.com/api/v1/resources/upload-file'
      this.$xhr.post(postUrl, fd)
        .then(res => {
          let obj = {
            name: res.data.file_name,
            url: res.data.file_path,
            id: res.data.id
          }
          this.uploadHUA.push(obj)
        })
        .catch(err => {
          this.$message.error(err.message)
        })
    },
    // 文件状态改变时的钩子 HUA
    handleHUAChange (file) {
      if (!file.name) {
        this.isShow = true
        this.uploadText = '请上传作品'
      } else {
        this.fileLength.push(file.name)
        this.isShow = false
        this.uploadText = ''
      }
    },
    // 文件列表移除文件时的钩子 HUA
    handleHUARemove (file) {
      this.uploadHUA = this.uploadHUA.filter(item => {
        return item.id !== file.id
      })
    },
    // 上传文件之前的钩子 ZIP
    beforeZIPUpload (file) {
      console.log(file.type)
      const isZIP = file.type.indexOf('zip') >= 0
      const isLt2M = file.size / 1024 / 1024 < 200
      if (!isZIP) {
        this.$message.error('上传文件只能是 zip 格式!')
        return isZIP
      }
      if (!isLt2M) {
        this.$message.error('上传文件大小不能超过 200MB!')
        return isLt2M
      }
      let fd = new FormData()
      fd.append('file', file)
      fd.append('type', 'zip') // 其他参数
      const postUrl = this.centervalidate == 0 ? 'http://api.lehuawang.dzhhb.com/api/v1/works/upload-file' : 'http://api.lehuawang.dzhhb.com/api/v1/resources/upload-file'
      this.$xhr.post(postUrl, fd)
        .then(res => {
          let obj = {
            name: res.data.file_name,
            url: res.data.file_path,
            id: res.data.id
          }
          this.uploadZIP.push(obj)
        })
        .catch(err => {
          this.$message.error(err.message)
        })
    },
    // 文件状态改变时的钩子 ZIP
    handleZIPChange (file) {
      if (!file.name) {
        this.isShow = true
        this.uploadText = '请上传作品'
      } else {
        this.fileLength.push(file.name)
        this.isShow = false
        this.uploadText = ''
      }
    },
    // 文件列表移除文件时的钩子 ZIP
    handleZIPRemove (file) {
      this.uploadZIP = this.uploadZIP.filter(item => {
        return item.id !== file.id
      })
    },
    // 跳转到列表页
    refreshView (status) {
      if (status == '成功') {
        history.go(0)
      } else {
        this.failTip = false
        this.upload = true
      }
    },
    // 类型选择开关
    onCenterpos () {
      if (this.isShow == 2 || this.isShow == '' || this.isShow == null || this.isShow == undefined) {
        this.$message.error('您只能发布作品')
        return
      }
      var leftValue = document.getElementById('center_pos').offsetLeft
      if (leftValue == 0) {
        document.getElementById('center_pos').style.left = 80 + 'px'
        this.centerPos = '教学资源'
        this.centervalidate = 1
      } else {
        document.getElementById('center_pos').style.left = 0 + 'px'
        this.centerPos = '作品'
        this.centervalidate = 0
      }
    },
    // 提交校验表单
    submitForm (formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.uploadWorks()
        } else {
          // 校验上传 S
          if (this.fileLength.length == 0) {
            this.isShow = true
            this.uploadText = '请上传作品'
          }
          // 校验上传 E
          console.log(this.centervalidate)
          return false
        }
      })
    },
    // 获取个人信息内容
    async accessPersonalInformation () {
      try {
        let pdata = await this.$xhr.get(apiInterface.userInfo, { params: {} })
        this.userName = pdata.data.name
        if (!this.userName) {
          this.$router.push({ path: '/personalcenter' })
        }
      } catch (error) {
        console.log(error)
        this.$message.error(error)
      }
    },
    // 获取作品类型列表
    async getWorkTypes () {
      try {
        let pdata = await this.$xhr.get(apiInterface.workTypes, {
          params: {}
        })
        if (pdata) {
          let arrList = []
          pdata.data.map(item => {
            let obj = {
              value: item.id,
              label: item.name
            }
            arrList.push(obj)
          })
          this.options = arrList
        }
      } catch (error) {
        this.$message.error(error.message)
      }
    },
    // 获取学校列表
    async getSchoolsList () {
      try {
        let pdata = await this.$xhr.get(apiInterface.schoolTeachersList, {
          params: {}
        })
        if (pdata) {
          let arrList = []
          if (pdata.data.length === 1) {
            arrList.push({
              value: pdata.data[0].id,
              label: pdata.data[0].name
            })
          } else {
            pdata.data.map(item => {
              let obj = {
                value: item.id,
                label: item.name
              }
              arrList.push(obj)
            })
          }
          this.optionsData = arrList.filter(item => item.label != this.userName)
        }
      } catch (error) {
        this.$message.error(error.message)
      }
    },
    // 上传接口
    async uploadWorks () {
      if (this.centervalidate == 0) { // 作品上传
        let data = []
        if (this.uploadJPG.length <= 0 || this.uploadHUA.length <= 0) {
          this.$message.error('请上传文件')
          return
        }
        this.uploadJPG.forEach(item => {
          data.push(item.id)
        })
        this.uploadHUA.forEach(item => {
          data.push(item.id)
        })
        try {
          let pdata = await this.$xhr.post(apiInterface.worksStore, {
            title: this.ruleForm.name, // 作品标题
            content: this.ruleForm.desc, // 作品内容
            type_id: this.ruleForm.region, // 作品类型
            teacher_id: this.ruleForm.send, // 发送老师
            attchment_ids: data // 上传需要的文件
          })
          if (pdata) {
            this.successTip = true
            this.upload = false
            this.isProcess = 2
          }
        } catch (error) {
          (this.failTip = true), (this.upload = false)
          this.$message.error(error.message)
        }
      } else { // 资源上传
        let data = []
        if (this.uploadJPG.length <= 0 || this.uploadHUA.length <= 0 || this.uploadZIP.length <= 0) {
          this.$message.error('请上传文件')
          return
        }
        this.uploadJPG.forEach(item => {
          data.push(item.id)
        })
        this.uploadHUA.forEach(item => {
          data.push(item.id)
        })
        this.uploadZIP.forEach(item => {
          data.push(item.id)
        })
        try {
          let pdata = await this.$xhr.post(apiInterface.resourceStore, {
            title: this.ruleForm.name, // 作品标题
            content: this.ruleForm.desc, // 作品内容
            // type_id: this.ruleForm.region, // 作品类型
            teacher_id: this.ruleForm.send, // 发送老师
            attchment_ids: data // 上传需要的文件
          })
          if (pdata) {
            this.successTip = true
            this.upload = false
            this.isProcess = 2
          }
        } catch (error) {
          (this.failTip = true), (this.upload = false)
          this.$message.error(error.message)
        }
      }
    },
  },
  created () {
    this.accessPersonalInformation()
    this.isProcess = 1
    this.getWorkTypes()
    this.getSchoolsList()
    if (this.isShow == 2 || !this.isShow) {
      this.centerArr.pop()
    }
  }
}
</script>

<style lang="scss">
input::-webkit-input-placeholder {
  color: red;
}

input::-moz-input-placeholder {
  color: red;
}

input::-ms-input-placeholder {
  color: red;
}

.formUpload {
  width: 575px;
}

.process {
  padding: 30px 0 20px 0;
}

.process li {
  width: 33%;
  float: left;
  text-align: center;
}

.process li em {
  width: 20px;
  height: 20px;
  display: inline-block;
  text-align: center;
  font-size: 12px/20px "Microsoft YaHei";
  color: #fff;
  background: #d8d8d8;
  border-radius: 50%;
  margin-right: 10px;
  font-weight: 200;
}

.process .processCur em {
  background: #15c1e4;
}

.process li span {
  display: inline-block;
  font: 12px/20px "Microsoft YaHei";
}

.el-upload-list__item:first-child {
  margin: 0;
}

.el-form-item__label {
  text-align: left;
  text-indent: 12px;
}

.el-input__inner,
.el-textarea__inner {
  background: #f4f4f4;
  color: #444;
}

.el-textarea__inner {
  height: 278px;
}

.el-upload__tip {
  margin: 0 0 0 6px;
  /*height: 20px;*/
  /*line-height: 20px;*/
  display: inline-block;
}

.el-button--primary,
.el-button--primary:focus,
.el-button--primary:hover {
  background: #15c1e4;
  border: #15c1e4 solid 1px;
}

.fileIntro {
  font: 12px/14px "Microsoft YaHei";
  color: #f56c6c;
  height: 14px;
  display: block;
  position: absolute;
  bottom: -15px;
  left: 0;
}

.switchBtn {
  border: #15c1e4 solid 1px;
  height: 34px;
  width: 160px;
  position: relative;
  border-radius: 20px;
  -webkit-border-radius: 20px;
  -moz-border-radius: 20px;
  -ms-border-radius: 20px;
}

.left_btn,
.right_btn,
.center_pos {
  display: block;
  width: 80px;
  height: 34px;
  text-align: center;
  font: 14px/34px "Microsoft YaHei";
  color: #15c1e4;
  -webkit-border-radius: 20px;
  -moz-border-radius: 20px;
  -ms-border-radius: 20px;
}

.left_btn {
  float: left;
  cursor: pointer;
}

.right_btn {
  float: right;
  cursor: pointer;
}

.center_pos {
  position: absolute;
  left: 0;
  top: 0;
  background: #15c1e4;
  border-radius: 20px;
  color: #fff;
}

.uploadbox {
  padding-left: 134px;
}

.uploadbox .information_modify_btn {
  width: 310px;
  height: 50px;
  margin: 10px 0 50px 70px;
}

.uploadSuccess {
  height: 400px;
  box-sizing: border-box;
  padding-top: 100px;
  margin: 0 auto;
  text-align: center;

  img {
    width: 70px;
  }

  p {
    margin-top: 50px;
    font-weight: 600;
    font-size: 15px;
  }
}

.upload-file-row {
  label.el-form-item__label {
    &:before {
      content: '*';
      color: #f56c6c;
      margin-right: 4px;
    }
  }

  .upload-jpg {
    margin-bottom: 10px;

    button {
      width: 134px;
      padding: 12px 15px;
      background-color: #ffffff;
      border: 1px solid #dcdfe6;
      color: #999;
      box-sizing: border-box;
    }
  }
}
</style>

